import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { AuthService } from './auth.service';

/**
 * Functional HTTP interceptor that attaches the JWT bearer token
 * to outgoing requests when the user is authenticated.
 *
 * Registration:
 *   provideHttpClient(withInterceptors([authInterceptor]))
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const authData = authService.getAuthData();
  if (authData?.accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authData.accessToken}`,
      },
    });
  }

  return next(req);
};
